import { render, staticRenderFns } from "./MiniUsers.vue?vue&type=template&id=0b5428a6&scoped=true&"
import script from "./MiniUsers.vue?vue&type=script&lang=js&"
export * from "./MiniUsers.vue?vue&type=script&lang=js&"
import style0 from "./MiniUsers.vue?vue&type=style&index=0&id=0b5428a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5428a6",
  null
  
)

export default component.exports